import { render, staticRenderFns } from "./IconButton.vue?vue&type=template&id=abf1ea88&scoped=true&"
import script from "./IconButton.js?vue&type=script&lang=js&"
export * from "./IconButton.js?vue&type=script&lang=js&"
import style0 from "./IconButton.scss?vue&type=style&index=0&id=abf1ea88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf1ea88",
  null
  
)

export default component.exports